class GroupHandler {
    constructor(name) {
        this.name = name;
        this.masters = [];
        this.children = [];
        this.watchers = [];
        this.enabled = 0;
        this.selected = 0;
    }

    _isRegistered(cbc) {
        return this.masters.indexOf(cbc) >= 0 || this.children.indexOf(cbc) >= 0;
    }

    addChild(cbc) {
        if (this._isRegistered(cbc)) throw new Error("Already registered");

        this.children.push(cbc);
        cbc.register('group', () => { this._updateMaster(); });
        this._updateMaster();
    }

    addMaster(cbc) {
        if (this._isRegistered(cbc)) throw new Error("Already registered");

        this.masters.push(cbc);
        cbc.register('group', () => {
            this.enabled = this.children.reduce((a, x) => x.disabled ? a : a + 1, 0);
            this.children.forEach(target => target.update('group', cbc.value));
            this.selected = cbc.value ? this.enabled : 0;
            this.watchers.forEach(fn => fn(this));
        });
    }

    _updateMaster() {
        this.selected = this.children.reduce((a, x) => x.value ? a + 1 : a, 0);
        this.enabled = this.children.reduce((a, x) => x.disabled ? a : a + 1, 0);
        var all = this.selected > 0 && this.enabled === this.selected;
        this.masters.forEach(target => target.update('group', all));
        this.watchers.forEach(fn => fn(this));
    }

    removeChild(cbc) {
        var index = this.children.indexOf(cbc);
        if (index >= 0) {
            this.children.splice(index, 1);
            cbc.remove('group');
            this._updateMaster();
        }
    }

    removeMaster(cbc) {
        var index = this.masters.indexOf(cbc);
        if (index >= 0) {
            this.masters.splice(index, 1);
            cbc.remove('group');
        }
    }

    addWatcher(fn) {
        this.watchers.push(fn);
    }

    removeWatcher(fn) {
        var index = this.watchers.indexOf(fn);
        if (index >= 0) {
            this.watchers.splice(index, 1);
        }
    }
}

var groups = {};
function findGroup(name) {
    if (typeof name !== 'string') return;
    if (name.length === 0) return;

    var group = groups[name];
    if (!group) {
        groups[name] = group = new GroupHandler(name);
    }

    return group;
}

angular.module("tromanWeb").directive("ergoCheckgroup", [function () {
    const namere = /^(master )?(\w+)$/;

    return {
        restrict: "A",
        require: ["ergoCheckbox", "ergoCheckgroup"],
        controller: function () {
            this.groups = [];
        },
        link: function (_scope, element, attributes, ctrls) {

            var ergoCheckbox = ctrls[0];
            var ergoCheckgroup = ctrls[1];

            var matches = attributes.ergoCheckgroup.split(',').map(x => x.match(namere));
            if (matches.some(x => !x)) return;

            matches.forEach(match => {
                if (!match) return;

                var group = findGroup(match[2]);
                if (!group) return;

                if (!match[1]) {
                    group.addChild(ergoCheckbox);
                    element.on('$destroy', function () { group.removeChild(ergoCheckbox); });
                } else {
                    group.addMaster(ergoCheckbox);
                    element.on('$destroy', function () { group.removeMaster(ergoCheckbox); });
                }

                ergoCheckgroup.groups.push(group);
            });
        }
    };
}]);

angular.module("tromanWeb").directive("ergoCheckgroupChanged", [function () {
    return {
        restrict: "A",
        require: "ergoCheckgroup",
        priority: 0.5, // Post-link after ergoCheckgroup
        link: function (scope, element, attributes, ergoCheckgroup) {

            let watcher = function (group) {
                scope.$evalAsync(() => {
                    scope.$evalAsync(attributes.ergoCheckgroupChanged, { $group: group.name, $selected: group.selected });
                });
            };

            for (let group of ergoCheckgroup.groups) {
                group.addWatcher(watcher);
                watcher(group);
            }

            element.on('$destroy', () => {
                for (let group of ergoCheckgroup.groups) {
                    group.removeWatcher(watcher);
                }
            });
        }
    };
}]);
